import React, { Fragment, useEffect, useState } from "react";
import { graphql } from "gatsby";
import SEO from "../components/SEO";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import { sanityClient } from "../utils/sanityFetch";
import BlogItem from "../components/Blog/BlogItem";
import Loader from "../components/loader";

const Search = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const getBlogs = async (param) => {
    const query = `query {
        allBlog(where: {title: {text: {matches: "/${param}/ig"}}}){
          title {
            text
            color {
              hex
            }
          }
          slug {
            current
          }
          thumbnail {
            alt
            asset {
              url
            }
          }
          publishedAt
        }
      }`;
    const response = await sanityClient(query);

    if (response?.data?.allBlog) {
      setList(response?.data?.allBlog);
    }
    setLoading(false);
  };
  useEffect(() => {
    const params = new URL(document.location).searchParams;
    const text = params.get("text");

    getBlogs(text);
  }, []);

  return (
    <Fragment>
      <Breadcrumb
        image={"/images/bg/breadcrumb-bg-four.jpg"}
        title={{ text: "Blog Search" }}
        content="Home"
      />
      <div className="section section-padding fix">
        <div className="container">
          {loading ? (
            <Loader />
          ) : list.length === 0 ? (
            <p className="text-center upercase">
              Sorry! There is no blog found :(
            </p>
          ) : (
            <div className="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6">
              {list?.map((item, key) => {
                return (
                  <div key={key} className="col mb-6" data-aos="fade-up">
                    <BlogItem data={item} />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Search;

export const query = graphql`
  {
    sanitySitesettings {
      favicon {
        asset {
          url
        }
      }
    }
  }
`;

export function Head({ location, data }) {
  return (
    <SEO
      location={location}
      data={{ title: "Search" }}
      favicon={data?.sanitySitesettings?.favicon}
    />
  );
}
